import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css'; // Assuming Footer.css will be created in the same directory

const Footer = () => {
  return (
    <footer className="app-footer">
      <div className="footer-content-wrapper">
        <div className="footer-links">
          <Link to="https://poreznik.ai/uslovi-koristenja" rel="noreferrer">Uslovi korištenja</Link>
          <Link to="https://poreznik.ai/pravila-koristenja" rel="noreferrer">Pravila korištenja</Link>
        </div>
        <div className="footer-payment-logos">
        <div className="container max-width-lg">
            <div className="col-12 text-center">
                <a href="https://www.mastercard.us/en-us.html" rel="noreferrer nofollow" target="_blank">
                <img 
                    loading="lazy" 
                    style={{ height: '54px' }} 
                    src="https://mojenaocale.ba/dev/assets/img/mastercard.png" 
                    alt="MasterCard" 
                />
                </a>
                <a href="http://www.maestrocard.com/gateway/index.html" rel="noreferrer nofollow" target="_blank">
                <img 
                    loading="lazy" 
                    style={{ height: '54px' }} 
                    src="https://mojenaocale.ba/dev/assets/img/maestro.png" 
                    alt="Maestro" 
                />
                </a>
                <a href="https://www.visasoutheasteurope.com/" rel="noreferrer nofollow" target="_blank">
                <img 
                    loading="lazy" 
                    style={{ height: '40px', marginLeft: '5px', marginTop: '12px', marginBottom: '7px' }} 
                    src="https://mojenaocale.ba/dev/assets/img/visa.png" 
                    alt="Visa" 
                />
                </a>
                <br />
                <a href="https://www.mastercard.ba/bs-ba/korisnici/podrska/sigurnost-i-zastita/identity-check.html" rel="noreferrer nofollow" target="_blank">
                <img 
                    loading="lazy" 
                    className="kartica" 
                    src="https://mojenaocale.ba/dev/assets/img/id-check.png" 
                    alt="MasterCard ID-Check" 
                    style={{ width: '80px', marginLeft: '5px', marginBottom: '10px' }} 
                />
                </a>
                <a href="https://www.visa.com.hr/products/visa-secure.html" rel="noreferrer nofollow" target="_blank">
                <img 
                    loading="lazy" 
                    className="kartica" 
                    src="https://mojenaocale.ba/dev/assets/img/visa-secure.jpg" 
                    alt="Visa Secure" 
                    style={{ width: '55px', marginLeft: '5px', marginBottom: '10px' }} 
                />
                </a>
                <a href="https://monri.ba/" rel="noreferrer nofollow" target="_blank">
                <img 
                    loading="lazy" 
                    src="https://mojenaocale.ba/dev/assets/img/monri.png" 
                    alt="web2pay" 
                    style={{ width: '190px', marginBottom: '6px' }} 
                />
                </a>
            </div>
            </div>
        </div>
        <div className="footer-copyright">
          <p>&copy; {new Date().getFullYear()} UIO AI. Sva prava zadržana.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
